import { translateObjectData } from '../../utils/locale';
import { generateEventId, urlify } from '../../utils/string';

const checkoutAnalytics = (items, setup, totals, fromList = {}) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const uniqueEventID = generateEventId();

	window.dataLayer.push({
		event: 'InitiateCheckout',
		event_id: uniqueEventID,
		values: {
			currency: setup.countries[setup.country].currency,
			content_type: 'product',
			contents: items.map((item) => ({
				id: item.item,
				quantity: item.quantity,
				item_price: item.priceEachAsNumber,
			})),
			num_items: items.reduce((acc, item) => (acc + parseInt(item.quantity, 10)), 0),
			value: totals.grandTotalPriceAsNumber,
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'InitiateCheckoutGA',
		ecommerce: {
			checkout: {
				actionField: { step: 1 },
				products: items.map((item) => ({
					name: item.name,
					id: item.item,
					sku: item.sku,
					price: item.priceEachAsNumber,
					brand: item.brand,
					category: item.category,
					variant: item.variant,
					quantity: item.quantity,
				})),
			},
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'begin_checkout',
		ecommerce: {
			'x-fb-event_id': uniqueEventID,
			items: items.map((item) => {
				const localizedItem = translateObjectData(setup, item);
				const itemCategory = localizedItem.canonicalUri && localizedItem.canonicalUri.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
				const itemId = item.item.slice(0, item.item.indexOf('-'));

				return {
					item_name: localizedItem.name,
					item_id: item.item,
					price: item.priceEachAsNumber,
					currency: setup.countries[setup.country].currency,
					item_brand: localizedItem.brand,
					...(itemCategory || {}),
					item_list_id: urlify(fromList[itemId] || ''),
					item_list_name: fromList[itemId] || '',
					item_variant: localizedItem.variant,
					quantity: `${item.quantity}`,
				};
			}),
		},
	});
};

export default checkoutAnalytics;
